<div class="container-fluid p-4 d-flex flex-column gap-3 max-content-height">
@if (businessList().length > 0) {
  <div class="d-flex gap-2">
    <button class="btn btn-light" (click)="goToDashboard()"><i class="far fa-caret-square-left fs-4"></i></button>
    <app-select-business-license class="flex-fill" [(businessId)]="businessId" [(branchId)]="branchId" [businessOnly]="true" [compactStyle]="true"></app-select-business-license>
    <mat-form-field subscriptSizing="dynamic" style="pointer-events: none;">
      <mat-label>Year End</mat-label>
      <mat-select [(ngModel)]="yearEnd" name="yearEnd">
      @for (m of monthsLong; track m; let i = $index) {
        <mat-option [value]="i">{{ m }}</mat-option>
      }
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Remaining Limit</mat-label>
      <input matInput type="number" [(ngModel)]="limit" placeholder="Remaining annual limit" />
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Accum Next Year CF</mat-label>
      <input matInput type="number" [(ngModel)]="accumNextYearCF" placeholder="Accum next year CF" />
    </mat-form-field>
  </div>
  <div class="d-flex justify-content-between">
  @if (submitted()) {
    <div class="h3 fw-bold text-danger border border-danger border-3 p-1 px-2 text-uppercase position-absolute start-50 translate-middle-x z-3">Submitted</div>
  }
    <div class="d-flex gap-2">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Year</mat-label>
        <mat-select [(ngModel)]="currentYear" name="currentYear">
          @for (y of years; track y) {
            <mat-option [value]="y">{{ y }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Month</mat-label>
        <mat-select [(ngModel)]="currentMonth" name="currentMonth">
          @for (m of monthsLong; track m; let i = $index) {
            <mat-option [value]="i">{{ m }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- <button class="btn btn-primary" (click)="postEInvoice()">Generate Excel</button> -->
    </div>
    <div class="d-flex gap-2">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Issuance Date</mat-label>
        <input matInput readonly [matDatepicker]="issuanceDatePicker" name="issuanceDate" [(ngModel)]="issuanceDate" required />
        <mat-datepicker-toggle matSuffix [for]="issuanceDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #issuanceDatePicker name="issuanceDate"></mat-datepicker>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Issuance Time</mat-label>
        <input matInput readonly [matTimepicker]="issuanceTimePicker" [(ngModel)]="issuanceDate" required [ngModelOptions]="{updateOn: 'blur'}">
        <mat-timepicker-toggle [for]="issuanceTimePicker" matSuffix/>
        <mat-timepicker #issuanceTimePicker/>
      </mat-form-field>
      @if (!submitted() && currentSelected().length > 0) {
        @if (selectionChanged()) {
          <button class="btn btn-primary" (click)="postEInvoice()">Save Selection</button>
        } @else if (dateChanged()) {
          <button class="btn btn-primary" (click)="updateEInvoiceDoc()">Update Date</button>
        } @else {
          <button class="btn btn-success" (click)="exportExcel()">Export Excel</button>
          <button class="btn btn-dark" title="Upload Submission Proof" (click)="uploadProof()"><i class="fas fa-file-upload"></i></button>
        }
      }
      @if (submitted()) {

      }
    </div>
  </div>

  <!-- #region 'Amount Card' -->
  <div class="d-grid gap-3 text-end" style="grid-auto-columns: 1fr; grid-auto-flow: column">
    <div class="card border-0 shadow p-3">
      <h4>{{ currentMonthAmount() || 0 | currency: "MYR" : "symbol-narrow" : "1.2-2" }}</h4>
      <div class="fs-5 fw-bold opacity-50">This Month</div>
    </div>
    <div class="card border-0 shadow p-3" [ngClass]="{ 'text-danger': currentAmount() > limit() }">
      <h4>{{ currentAmount() | currency: "MYR" : "symbol-narrow" : "1.0-0" }} ({{ (currentAmount() / limit()) * 100 | number: "1.1-1" }}%)</h4>
      <div class="fs-5 fw-bold opacity-50">UpToDate Amount</div>
    </div>
    <div class="card border-0 shadow p-3" [ngClass]="{ 'text-danger': limit() - currentAmount() < 0 }">
      <h4>{{ limit() - currentAmount() || 0 | currency: "MYR" : "symbol-narrow" : "1.0-0" }}</h4>
      <div class="fs-5 fw-bold opacity-50">UpToDate Balance</div>
    </div>
    <div class="card border-0 shadow p-3" [ngClass]="{ 'text-danger': projectedAmount() > limit() }">
      <h4>{{ projectedAmount() | currency: "MYR" : "symbol-narrow" : "1.0-0" }} ({{ (projectedAmount() / limit()) * 100 | number: "1.1-1" }}%)</h4>
      <div class="fs-5 fw-bold opacity-50">This Year Projected</div>
    </div>
    <div class="card border-0 shadow p-3" [ngClass]="{ 'text-danger': limit() - projectedAmount() < 0 }">
      <h4>{{ limit() - projectedAmount() || 0 | currency: "MYR" : "symbol-narrow" : "1.0-0" }}</h4>
      <div class="fs-5 fw-bold opacity-50">Projected Balance</div>
    </div>
    <div class="card border-0 shadow p-3">
      <h4>{{ nextYearCF() | currency: "MYR" : "symbol-narrow" : "1.0-0" }}</h4>
      <div class="fs-5 fw-bold opacity-50">CF Next Year</div>
    </div>
  </div>
  <!-- #endregion -->

  <!-- #region 'table' -->
  <div class="flex-fill overflow-auto shadow">
    <table mat-table [dataSource]="table.dataSource()" matSort (matSortChange)="table.sortState.set($event)">
      <ng-container matColumnDef="File">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let l">
          <span (click)="openFormJ(l)" class="pointer"><i class="far fa-file-alt"></i></span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      @for (c of table.config(); track c.columnDef) {
        <ng-container [matColumnDef]="c.columnDef">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="c.cssClass?.header">{{ c.header }}</th>
          <td mat-cell *matCellDef="let s" [class]="c.cssClass?.cell">
            @if (c.type === "boolean") {
              <mat-checkbox [checked]="s[c.property]" disabled="true"></mat-checkbox>
            } @else {
              @if (c.onClick) {
                <div (click)="c.onClick(s)" class="pointer">{{ table.formatValue(s, c) }}</div>
              } @else {
                {{ table.formatValue(s, c) }}
              }
            }
          </td>
          <td mat-footer-cell *matFooterCellDef [class]="c.cssClass?.footer">{{ c.footer ? table.formatValue(formJSelection(), c, true) : "" }}</td>
        </ng-container>
      }
      @for (m of absMonths(); track m.id; let i = $index) {
        <ng-container [matColumnDef]="m.name">
          <th mat-header-cell *matHeaderCellDef [class.bg-warning-subtle]="m.id === absCurrentMonth() && table.dataSource()?.length > 0">{{ sharedService.formatMonth(m.month, "short") }}</th>
          <td mat-cell [class.bg-warning-subtle]="m.id === absCurrentMonth() && table.dataSource()?.length > 0" *matCellDef="let l">
            @if (m.id > l.absStartMonth && m.id <=l.absEndMonth) {
              <div class="form-check fs-6">
                <input class="form-check-input" type="checkbox" [disabled]="submitted() || m.id !== absCurrentMonth() || l.months[Status.Submitted]?.includes(m.id)" [checked]="l.months[Status.Selected]?.includes(m.id) || l.months[Status.Submitted]?.includes(m.id)" (change)="toggleSelect(l, $event.target.checked)" />
              </div>
            }
          </td>
          <td mat-footer-cell [class.bg-warning-subtle]="m.id === absCurrentMonth() && table.dataSource()?.length > 0" *matFooterCellDef></td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
      <tr mat-row *matRowDef="let l; columns: displayedColumns()" [class.d-none]="l.show === false" [class.bg-danger-subtle]="l.cancelled === true"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns(); sticky: true"></tr>
      <tr *matNoDataRow>
        <td class="no-data-cell p-3 fw-semibold" [attr.colspan]="displayedColumns().length">No record found.</td>
      </tr>

      <!-- Group header -->
      <ng-container matColumnDef="groupHeader">
        <td mat-cell [attr.colspan]="displayedColumns().length - 16" *matCellDef="let group">
          <div class="d-flex gap-2 align-items-center">
            <span class="me-1 text-secondary">
            @if (group.expanded) {
              <i class="fas fa-chevron-down"></i>
            } @else {
              <i class="fas fa-chevron-right"></i>
            }
            </span>
          @if (!submitted()) {
            <input class="form-check-input" type="checkbox" [disabled]="submitted()" [checked]="group.selectedCount === group.selectableCount" (change)="toggleSelectAll(group, $event.target.checked)" appStopPropagation />
          }
            <strong>{{ group.selected ? 'Previous Selected' : group.selected === false ? 'Not Selected' : 'Current Month' }} ({{ group.selectedCount }} / {{ group.selectionListCount }})</strong>
          </div>
          <!-- <button appStopPropagation class="btn btn-sm btn-primary ms-1" (click)="toggleSelectAll(group, group.selectedCount !== group.selectableCount)">{{ (group.selectedCount !== group.selectableCount) ? 'Select All' : 'Deselect All' }}</button> -->
        @if (group.selected && hasCancelledLoan(group)) {
          <div class="mx-3 badge text-bg-danger"><i class="fas fa-exclamation-triangle"></i> Has Cancelled Loans!</div>
        }
        </td>
      </ng-container>
      <ng-container matColumnDef="groupCurrentAmount">
        <td mat-cell class="text-end fw-bold" *matCellDef="let group">{{ getSubCurrentAmount(group) | currency: "MYR" : "symbol-narrow" : "1.2-2" }}</td>
      </ng-container>
      <ng-container matColumnDef="groupTotal">
        <td mat-cell class="text-end fw-bold" *matCellDef="let group">{{ getSubTotal(group) | currency: "MYR" : "symbol-narrow" : "1.2-2" }}</td>
      </ng-container>
      <ng-container matColumnDef="groupCF">
        <td mat-cell [attr.colspan]="2" class="text-end fw-bold" *matCellDef="let group">{{ getSubCF(group) | currency: "MYR" : "symbol-narrow" : "1.2-2" }}</td>
      </ng-container>
      <tr mat-row *matRowDef="let group; columns: groupHeaderColumns(); when: isGroupHeader" class="bg-light position-sticky" style="top: 56px; z-index: 3" (click)="toggleCollapse(group.group)" [ngClass]="{ 'text-secondary': group.selected === false }"></tr>
    </table>
  </div>
  <!-- #endregion -->
}
</div>

<ng-template #formJDetails let-data>
  <div class="grid-2-col column-gap-5 fit-width border-bottom pb-4 mb-4">
    <div class="grid-3-col column-gap-2 fit-width">
      <div>Customer Name</div>
      <div class="fst-normal">:</div>
      <div class="fw-bold">{{ data.formJ.CustomerName }}</div>
      <div>Stamped Date</div>
      <div class="fst-normal">:</div>
      <div class="fw-bold">{{ data.formJ.DateStamped | date: 'dd MMM yyyy' }}</div>
      <div>Principal</div>
      <div class="fst-normal">:</div>
      <div class="fw-bold">{{ data.formJ.Principal | currency: "MYR" : "symbol-narrow" : "1.2-2" }}</div>
      <div>Monthly Payment</div>
      <div class="fst-normal">:</div>
      <div class="fw-bold">{{ data.formJ.PaymentSchedule[0].amount | currency: "MYR" : "symbol-narrow" : "1.2-2" }}</div>
    </div>
    <div class="grid-3-col column-gap-2 fit-width">
      <div>Customer IC</div>
      <div class="fst-normal">:</div>
      <div class="fw-bold">{{ data.formJ.IcNumber }}</div>
      <div>Form J Date</div>
      <div class="fst-normal">:</div>
      <div class="fw-bold">{{ data.formJ.Date | date: 'dd MMM yyyy' }}</div>
      <div>Term</div>
      <div class="fst-normal">:</div>
      <div class="fw-bold">{{ data.formJ.Term }}</div>
      <div>Last Payment</div>
      <div class="fst-normal">:</div>
      <div class="fw-bold">{{ data.formJ.LastPayment | currency: "MYR" : "symbol-narrow" : "1.2-2" }}</div>
    </div>
  </div>
</ng-template>
